/* eslint-disable max-len */

import React from 'react';

type DeleteXPropTypes = React.SVGProps<SVGSVGElement> & {
  width?: string;
  height?: string;
  circleFill?: string;
  circleStroke?: string;
  iconFill?: string;
};

export const DeleteX: React.FC<DeleteXPropTypes> = ({
  width,
  height,
  circleFill,
  circleStroke,
  iconFill,
  ...svgProps
}) => (
  <svg
    {...svgProps}
    width={width}
    height={height}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="13" height="13" rx="6.5" fill={circleFill} />
    <rect x="0.5" y="0.5" width="13" height="13" rx="6.5" stroke={circleStroke} strokeWidth={1} />
    <path
      d="M9.91016 4.67578L7.58594 7L9.91016 9.32422L9.32422 9.91016L7 7.58594L4.67578 9.91016L4.08984 9.32422L6.41406 7L4.08984 4.67578L4.67578 4.08984L7 6.41406L9.32422 4.08984L9.91016 4.67578Z"
      fill={iconFill}
    />
  </svg>
);

DeleteX.defaultProps = {
  width: '0.875rem',
  height: '0.875rem',
  circleFill: 'red',
  circleStroke: 'white',
  iconFill: 'white',
};
